// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__l+4s5","header":"Layout_header__R8zn8","headerHidden":"Layout_headerHidden__536P0","main":"Layout_main__gSmqu"};